import { useState } from "react"
import { IoClose } from "react-icons/io5";
import {
  Box,
  Center,
  HStack,
  Icon,
  Stack,
} from "@chakra-ui/react"
import { Text } from "@/components"
import { StockOptionType, TaxCalculation } from "@/types"
import { parse } from "@/utils"

interface Props {
  index: number
  taxCalculation: TaxCalculation
  isDeletable: boolean
  setAmount: (index: number, amount: number) => void
  setStrikePrice: (index: number, strikePrice: number) => void
  setStockOptionType: (index: number, type: string) => void
  deleteTaxCalculation: (index: number) => void
}

export const TaxCalculationRow = ({
  index,
  taxCalculation,
  isDeletable,
  setAmount,
  setStrikePrice,
  setStockOptionType,
  deleteTaxCalculation
}: Props) => {
  const [currentOptionType, setCurrentOptionType] = useState<string>(taxCalculation.type ?? StockOptionType.ISO)

  const handleAmountChange = (value: string) => {
    setAmount(index, parseInt(value))
  }

  const handleStrikePriceChange = (value: string) => {
    setStrikePrice(index, parseFloat(parse(value)))
  }

  const handleOptionTypeChange = (value: string) => {
    setCurrentOptionType(value)
    setStockOptionType(index, value)
  }
  
  const OPTION_TYPES = [
    { label: "ISO", value: StockOptionType.ISO },
    { label: "NSO", value: StockOptionType.NSO },
  ]

  return (
    <Stack p={5} borderRadius={10} bg="gray.50" w="100%" boxShadow="sm">
      <HStack>
        <Text fontSize="2xl" fontWeight="bold">
          { `Grant ${index + 1}` }
        </Text>
        <Box flex={1} />
        {
          isDeletable && (
            <Center
              border="1px solid #E2E8F0"
              borderRadius={5}
              boxSize={8}
              cursor="pointer"
              _hover={{ bg: "gray.200" }}
              onClick={() => deleteTaxCalculation(index)}
            >
              <Icon as={IoClose as React.ElementType} color="text.primary" />
            </Center>
          )
        }
      </HStack>
      <HStack gap={5} key={index}>
        <Stack w="30%" borderRadius={10} bg="card.bg" p={5}>
          <Text fontSize={15} textAlign="left">
            Amount Vested
          </Text>
          {/* <DollarInput value={taxCalculation.amount} setValue={handleAmountChange} /> */}
        </Stack>
        <Stack w="30%" borderRadius={10} bg="card.bg" p={5}>
          <Text fontSize={15} textAlign="left">
            Stock Option Type
          </Text>
          <select
            value={currentOptionType}
            onChange={(e) => handleOptionTypeChange(e.target.value)}
            style={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "6px 10px",
              outline: "none",
            }}
          >
            <option value="">-- Select --</option>
            {OPTION_TYPES.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </Stack>
        <Stack w="30%" borderRadius={10} bg="card.bg" p={5}>
          <Text fontSize={15} textAlign="left">
            Strike Price
          </Text>
          {/* <DollarInput value={format(String(taxCalculation.strikePrice))} setValue={handleStrikePriceChange} /> */}
        </Stack>
      </HStack>
    </Stack>
  )
}
